import * as routeParams from './routeParams';

export const AGE_GATE = '/age-gate';
export const APP_LOCKED = '/app-locked';
export const BROWSER_VERIFICATION = '/browser-verification';
export const CANNOT_DETECT_LOCATION = '/cannot-detect-location';
export const CONTACT_US = '/contact-us';
export const CHECKING_UPDATE = '/checking-update';
export const DEVICE = '/device';
export const ERROR_PAGE = '/error';
export const IMPORTANT = '/important';
export const LEGAL_DISCLAIMER = '/legal-disclaimer';
export const NOT_AVAILABLE = '/service-not-available';
export const NOT_COMPATIBLE_BROWSER = '/not-compatible-browser';
export const PAIRING_ALERT = '/pair-alert';
export const PAIRING_GUIDE = '/pair';
export const PAIRING_GUIDE_PARAMETERIZED = `${PAIRING_GUIDE}/:${routeParams.DEVICE_TYPE}/:${routeParams.BLE_PAIRING_GUID}?`;
export const PAIRING_GUIDE_HID = '/pair-hid';
export const PAIRING_GUIDE_HID_PARAMETRIZED = `${PAIRING_GUIDE_HID}/:${routeParams.USB_CONNECTION_RETRY}?`;
export const PAIRING_SUCCESS = '/pair-success';
export const RESET_DEVICE = '/reset';
export const ROOT = '/';
export const SELECT_DEVICE = '/select-device';
export const SUMMARY_UPDATE = '/summary-update';
export const CONNECTING = '/connecting';
export const TNC = '/tnc';
export const TNC_DATA_COLLECTION = `${TNC}/data-collection`;
export const TNC_DATA_PREFERENCE = `${TNC}/preference-center`;
export const TNC_TERMS_OF_USE = `${TNC}/terms-of-use`;
export const UPDATE = '/update';
export const UP_TO_DATE = '/up-to-date';
export const UP_TO_DATE_PARAMETERIZED = `${UP_TO_DATE}/:${routeParams.SUCCESS_FWU_COUNT}`;
export const UP_TO_DATE_FAILED = '/up-to-date-failed';
export const WILDCARD = '*';
